import { types } from "../types/types";

const initialState = { isAuthenticated: false,
                       nomUsuario: "",
                       altoContenedor: 0,
                       docente: -1,
                       error: false,
                       añoLectivo: 0 
                    }

export const auth = ( state = initialState, action ) => {
    switch (action.type) {
        case types.autAutenticado:
            return { ...state,
                    isAuthenticated: action.payload.autenticado,
                     docente: action.payload.docente,
                     altoContenedor: action.payload.altoContenedor,
                     nomUsuario: action.payload.nomUsuario,
                     añoLectivo: action.payload.añoLectivo };
        case types.autLogout:
            return { ...state,
                    isAuthenticated: false,
                     docente: -1,
                     nomUsuario: "",
                     añoLectivo: 0 }
        case types.autAutenticacionError:
            return { ...state,
                     error: action.payload }
        default:
            return state;
    }
 }